import React, { Component } from 'react';
import IHCLogo from 'dataModule/assets/img/HealthBeats.svg';

export default class BrandLogo extends Component {
  render() {
    const { width = 400, height = 100, ...rest } = this.props;
    return <img src={IHCLogo} width={width} height={height} {...rest} />;
  }
}
